import { AttributeValue, ProductSearchResult } from "@msdyn365-commerce/retail-proxy";

const AlcoholAttributeName = 'Alkoholvare';
const BamaAttributeName = 'Bama';
const CocaColaAttributeName = 'Coca-Cola';
const TobaccoAttributeName = 'Tobakk';
const TransitAttributeName = 'Transitt';

export type ValidateProductAccessResult = {
    RecordId: number;
    HasAccess: boolean;
};

export function validateProductAccess(customerAttributes: AttributeValue[], productAttributes: AttributeValue[]) {
    const custAlcohol = Number(customerAttributes.find((attr) => attr.Name === AlcoholAttributeName)?.TextValue) || 0;
    const custBama = Number(customerAttributes.find((attr) => attr.Name === BamaAttributeName)?.TextValue) || 0;
    const custCocaCola = Number(customerAttributes.find((attr) => attr.Name === CocaColaAttributeName)?.TextValue) || 0;
    const custTobacco = Number(customerAttributes.find((attr) => attr.Name === TobaccoAttributeName)?.TextValue) || 0;
    const custTransit = Number(customerAttributes.find((attr) => attr.Name === TransitAttributeName)?.TextValue) || 0;

    const prodAlcohol = Number(productAttributes.find((attr) => attr.Name === AlcoholAttributeName)?.TextValue) || 0;
    const prodBama = Number(productAttributes.find((attr) => attr.Name === BamaAttributeName)?.TextValue) || 0;
    const prodCocaCola = Number(productAttributes.find((attr) => attr.Name === CocaColaAttributeName)?.TextValue) || 0;
    const prodTobacco = Number(productAttributes.find((attr) => attr.Name === TobaccoAttributeName)?.TextValue) || 0;
    const prodTransit = Number(productAttributes.find((attr) => attr.Name === TransitAttributeName)?.TextValue) || 0;

    return [
        custAlcohol >= prodAlcohol,
        custBama >= prodBama,
        custCocaCola >= prodCocaCola,
        custTobacco >= prodTobacco,
        custTransit >= prodTransit
    ].every(Boolean);
}

export function validateProductAccessArray(
    customerAttributes: AttributeValue[] | undefined,
    products: ProductSearchResult[] | undefined
): ValidateProductAccessResult[]  {
    if (!products) {
        return [];
    }

    const results: ValidateProductAccessResult[] = [];
    const custAlcohol = Number(customerAttributes?.find((attr) => attr.Name === AlcoholAttributeName)?.TextValue) || 0;
    const custBama = Number(customerAttributes?.find((attr) => attr.Name === BamaAttributeName)?.TextValue) || 0;
    const custCocaCola = Number(customerAttributes?.find((attr) => attr.Name === CocaColaAttributeName)?.TextValue) || 0;
    const custTobacco = Number(customerAttributes?.find((attr) => attr.Name === TobaccoAttributeName)?.TextValue) || 0;
    const custTransit = Number(customerAttributes?.find((attr) => attr.Name === TransitAttributeName)?.TextValue) || 0;

    for (const product of products) {
        const productAttributes = product.AttributeValues;

        if (!productAttributes) {
            continue;
        }

        const prodAlcohol = Number(productAttributes.find((attr) => attr.Name === AlcoholAttributeName)?.TextValue) || 0;
        const prodBama = Number(productAttributes.find((attr) => attr.Name === BamaAttributeName)?.TextValue) || 0;
        const prodCocaCola = Number(productAttributes.find((attr) => attr.Name === CocaColaAttributeName)?.TextValue) || 0;
        const prodTobacco = Number(productAttributes.find((attr) => attr.Name === TobaccoAttributeName)?.TextValue) || 0;
        const prodTransit = Number(productAttributes.find((attr) => attr.Name === TransitAttributeName)?.TextValue) || 0;

        if (![
            custAlcohol >= prodAlcohol,
            custBama >= prodBama,
            custCocaCola >= prodCocaCola,
            custTobacco >= prodTobacco,
            custTransit >= prodTransit
        ].every(Boolean)) {
            results.push({
                RecordId: product.RecordId,
                HasAccess: false
            });
        } else {
            results.push({
                RecordId: product.RecordId,
                HasAccess: true
            });
        }
    }

    return results;
}
